var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3465_4964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7422 8.85156L2.24219 1.35117C2.08359 1.2832 1.91641 1.21484 1.75078 1.21484C1.41395 1.21484 1.08281 1.35152 0.840626 1.60742C0.480536 2.02383 0.39754 2.58984 0.631915 3.05898L4.25 10L0.632032 16.9414C0.397657 17.4109 0.480665 17.9766 0.840782 18.3582C1.0825 18.6139 1.41344 18.7508 1.75016 18.7508C1.91617 18.7508 2.0834 18.7178 2.24195 18.6495L19.7422 11.1484C20.2023 10.9519 20.5004 10.4996 20.5004 9.99961C20.4648 9.5 20.2031 9.04688 19.7422 8.85156ZM1.74922 2.50117C1.74844 2.50156 1.74961 2.50039 1.74922 2.50117L17.793 9.375H5.33203L1.74922 2.50117ZM1.74024 17.5195L5.33203 10.625H17.7578L1.74024 17.5195Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3465_4964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSend);
export default __webpack_public_path__ + "static/media/btnSend.2e8771573b089c98b3d822d0786355b7.svg";
export { ForwardRef as ReactComponent };